import { render, staticRenderFns } from "./ProzessCustomFieldData.vue?vue&type=template&id=79b5aa59"
import script from "./ProzessCustomFieldData.vue?vue&type=script&lang=js"
export * from "./ProzessCustomFieldData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports